import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import { Provider, connect } from 'react-redux'
import { Router } from 'react-router'
import routes from '../../routes'
import './../../assets/styles/reset.css'
/*import { getHelpdeskMail } from '../../utils'
import {
  open as openChatbot,
  close as closeChatbot
} from '../../state/actions/chatbotActions'*/
import { /*css,*/ withStyles } from '../../styles/withStyles'
import Styles from './styles'
//import Chatbot from '@hype/chatbot'

// import i18n from '../i18n'
// import ru from './../../lang/ru.json'
// import en from './../../lang/en.json'

// const localeData = {
//   en,
//   ru,
// }

// const DEFAULT_LOCALE = 'en'

const handleChange = ({ partnership }, { partnership: nextPartnership }) => {
  if (!partnership || !nextPartnership) {
    window.scrollTo(0, 0)
  }
}

class Root extends Component {
  constructor(props) {
    super(props)
  }

  // getLocation() {
  //   return this.props.store.getState().getIn(['routing', 'locationBeforeTransitions']).toJS()
  // }

  // setLanguage(lang) {
  //   const location = this.getLocation()

  //   if (localeData[lang]) {
  //     this.props.history.push({...location, query: {...location.query, lang } })
  //     window.location.reload()
  //   }
  // }

  render() {
    const {
      /*dispatch,*/
      store,
      history,
      routing,
      product,
      /*step,
      chatbot,*/
      children
    } = this.props
    // const lang = localeData[this.getLocation().query.lang] ? this.getLocation().query.lang || DEFAULT_LOCALE : DEFAULT_LOCALE
    // const i18nTools = new i18n.Tools({ localeData: localeData[lang], locale: lang })

    /*const chatbotProps = {
      open: chatbot.open,
      afterOpenCallback: () => {
        dispatch(openChatbot())
      },
      afterCloseCallback: () => {
        dispatch(closeChatbot())
      },
      theme: {
        color: this.props.styles.chatbot._definition.backgroundColor,
        height: '420px',
        width: '340px',
        padding: '50px',
        fontFamily: 'Muli, sans-serif',
        buttonSize: '64px'
      },

      contactId: step.contactId,
      chatbotName: 'Hypebot',
      emailAddress: getHelpdeskMail(routing),

      endpoint:
        'https://westus.api.cognitive.microsoft.com/qnamaker/v2.0/knowledgebases/57858072-d02e-4dd6-bd72-73da2d55eb5b/generateAnswer',
      subKey: '35f376e3f5294748886e1cd937a75f3e',
      operatorChatURL: `${process.env.API_ROOT.replace(
        /\/onboarding/,
        ''
      )}/Chat/`,
      __hypeCheck: `${process.env.API_ROOT.replace(
        /\/onboarding/,
        ''
      )}/api/rest/FREE/services`
    }*/

    return (
      <Provider store={store}>
        <div className="pos-onboarding-root-wrapper">
          {/*<i18n.Provider
              i18n={i18nTools}
              setLanguage={this.setLanguage}
            >*/}
          <Router
            history={history}
            routes={routes}
            onUpdate={() => handleChange(routing, product)}
          />
          {/*</i18n.Provider>*/}
          {children}
          {/*<div {...css(this.props.styles.chatbot)}>
            <Chatbot {...chatbotProps} />
          </div>*/}
        </div>
      </Provider>
    )
  }
}

Root.propTypes = {
  children: PropTypes.node,
  history: PropTypes.object,
  store: PropTypes.object.isRequired
}

const mapStateToProps = (state /*, ownProps*/) => {
  return state
}

export default connect(mapStateToProps)(withStyles(Styles)(Root))



// WEBPACK FOOTER //
// ./containers/root/index.js